<template>
  <div class="companyprofile">
    <div class="bg">
      <img src="@imgs/gsjjbg.png" width="341px" height="93px" alt="" class="cpzx" />
    </div>
    <div class="companybrief">
      <div class="title">
        <div class="raio"></div>
        <span>公司简介</span>
        <div class="raio"></div>
      </div>
      <div class="content">
        <p>山东旭海现代医药物流有限公司成立于2023年05月11日，注册地位于山东省济南市槐荫区美里东路3000号德迈国际信息产业园二期48-101，法定代表人为黄海平。经营范围包括许可项目：道路货物运输（不含危险货物）；药品批发；药品零售；药品互联网信息服务；医疗器械互联网信息服务；第三类医疗器械租赁；第三类医疗器械经营。（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）一般项目：消毒剂销售（不含危险化学品）；卫生用杀虫剂销售；化工产品销售（不含许可类化工产品）；专用化学产品销售（不含危险化学品）；实验分析仪器销售；日用品销售；日用品批发；办公用品销售；电子产品销售；化妆品批发；化妆品零售；食品添加剂销售；食品互联网销售（仅销售预包装食品）；婴幼儿配方乳粉及其他婴幼儿配方食品销售；保健食品（预包装）销售；特殊医学用途配方食品销售；卫生用品和一次性使用医疗用品销售；互联网销售（除销售需要许可的商品）；第一类医疗器械销售；第一类医疗器械租赁；第二类医疗器械租赁；第二类医疗器械销售；医护人员防护用品批发；医护人员防护用品零售；医用口罩批发；医用口罩零售；供应链管理服务；国内货物运输代理；普通货物仓储服务（不含危险化学品等需许可审批的项目）；运输设备租赁服务；广告设计、代理；市场营销策划；市场调查（不含涉外调查）；企业管理；会议及展览服务；计算机软硬件及辅助设备批发；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；软件开发；软件销售；健康咨询服务（不含诊疗服务）；养生保健服务（非医疗）；中医养生保健服务（非医疗）；医学研究和试验发展；信息咨询服务（不含许可类信息咨询服务）；非居住房地产租赁；计算机及通讯设备租赁；信息系统集成服务；货物进出口。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      proList: [
        { id: 0, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 1, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 2, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 3, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 4, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 5, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 6, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 7, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 8, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 9, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 10, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 11, img: require("@imgs/pricer.png"), title: "西洋参" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.companyprofile {
  .companybrief {
    margin-top: 30px;

    .title {
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #fe2a1e;
      display: flex;
      justify-content: center;
      align-items: center;

      .raio {
        width: 6px;
        height: 6px;
        background: #fe2a1e;
        border-radius: 50%;
        display: inline-block;
      }

      span {
        margin: 0 7px;
      }
    }

    .content {
      width: 1187px;
      margin: 0 auto;
      margin-bottom: 30px;
      text-align: left;
      font-size: 18px;
      font-family: DengXian;
      color: #666666;
    }
  }
}
</style>